import './InfiniteScroll.less'
import InfiniteScroll from './InfiniteScroll'

export default InfiniteScroll
